import { render } from "./SegmentationsPanel.vue?vue&type=template&id=9cff767a&scoped=true"
import script from "./SegmentationsPanel.vue?vue&type=script&lang=ts"
export * from "./SegmentationsPanel.vue?vue&type=script&lang=ts"

import "./SegmentationsPanel.vue?vue&type=style&index=0&id=9cff767a&lang=scss&scoped=true"
import "./SegmentationsPanel.vue?vue&type=style&index=1&id=9cff767a&lang=scss"
script.render = render
script.__scopeId = "data-v-9cff767a"

export default script